export type KeyValueObject = Record<string, any>;

export function isRecord(value: unknown): value is KeyValueObject {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
